import {
  LOGIN_DATA,
  UPDATE_FULL_SCREEN_LOADER,
  UPDATE_ONBOARDING_STATE,
} from "../actionTypes/authTypes";

const initalState = {
  isUserloggedIn: false,
  isLoading: false,
  onboardingState: "",
};

export function authReducer(state = initalState, action) {
  switch (action.type) {
    case LOGIN_DATA:
      return {
        ...state,
        isUserloggedIn: action.payload,
      };
    case UPDATE_FULL_SCREEN_LOADER:
      return {
        ...state,
        isLoading: action.payload,
      };
    case UPDATE_ONBOARDING_STATE:
      return {
        ...state,
        onboardingState: action.payload,
      };

    default:
      return state;
  }
}
